/** web-studio-sites D7: what the events row's current state requires a drawing to show (its standard look draws nothing with no event). */
import type { SiteEventSummaryDto } from '@telify/shared';

import type { RequiredPart, RequiredParts } from '../../contract/required';
import type { EventsRowState, MineMark } from './contract';

/**
 * One event card each: the entry, the card, the name, the price, and Book opening the event; on an event the client
 * has booked (the mine option), the mark's button opening the booking in Book's place.
 */
export function eventCardsRequired(events: readonly SiteEventSummaryDto[], marks: Readonly<Record<string, MineMark>>): RequiredPart[] {
  return events.flatMap((e) => [
    { part: 'item', item: e.id },
    ...['card', 'name', 'price'].map((part) => ({ part, item: e.id, in: 'item' })),
    marks[e.id]
      ? { part: 'mine-action', item: e.id, in: 'item', action: 'openBooking' }
      : { part: 'book', item: e.id, in: 'item', action: 'open' },
  ]);
}

export const requiredParts: RequiredParts<EventsRowState> = (state) =>
  state.events.length === 0 ? [] : [{ part: 'track' }, ...eventCardsRequired(state.events, state.marks)];
